export default __webpack_public_path__ + "static/media/babel.5063da0c.svg";